import { render, staticRenderFns } from "./GridContent.vue?vue&type=template&id=2885c587&"
import script from "./GridContent.vue?vue&type=script&lang=js&"
export * from "./GridContent.vue?vue&type=script&lang=js&"
import style0 from "./GridContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports